/**
 * Backbone wrapper
 */
define(function(require, exports, module) {
    'use strict';

    var Cocktail = require('cocktail');
    var Backbone = require('../node_modules/backbone/backbone');
    var historyUtil = require('util/history.util');
    var storage = require('util/storage.util');

    // mixins for Backbone
    Cocktail.patch(Backbone);

    Backbone.History.prototype.decodeFragment = function(fragment) {
        // just allow app to proceed loading in case malformed URL
        try {
            return decodeURI(fragment.replace(/%25/g, '%2525'));
        } catch(e) {
            console.warn(e);
            return '';
        }
    };

    Backbone.History.prototype.getPath = (function(getPath) {
        return function() {
            if (location.href === historyUtil.baseURI) {
                return getPath.apply(this, arguments);
            }
            var search = historyUtil.baseURI.replace(/#.*/, '').match(/\?.+/);

            var path = this.decodeFragment(
                historyUtil.baseURI.split('?')[0]
                    .replace(/^.*\/\/[^\/]+/, '')
                    .replace(/^\/?/, '/') + (search ? search[0] : '')
            ).slice(this.root.length - 1);
            return path.charAt(0) === '/' ? path.slice(1) : path;
        };
    })(Backbone.History.prototype.getPath);

    // Based on Backbone.js 1.3.3
    // Added state to `pushState`/`replaceState` call

    // Cached regex for stripping urls of hash.
    var pathStripper = /#.*$/;

    /**
     * Add frame id to the history state for calculate a navigation direction
     * @private
     */
    var _handleNavigationDirection = function(state) {
        var LAST_FRAME_ID_KEY = 'lastHistoryFrameId';

        var lastFrameId = storage.session.getItem(LAST_FRAME_ID_KEY);
        var currentFrameId = state[LAST_FRAME_ID_KEY];

        if (currentFrameId == null) { // new frame
            if (lastFrameId == null) {
                lastFrameId = 1;
            }

            currentFrameId = lastFrameId + 1;

            state[LAST_FRAME_ID_KEY] = currentFrameId;
        }
    };

    // Save a fragment into the hash history, or replace the URL state if the
    // 'replace' option is passed. You are responsible for properly URL-encoding
    // the fragment in advance.
    //
    // The options object can contain `trigger: true` if you wish to have the
    // route callback be fired (not usually desirable), or `replace: true`, if
    // you wish to modify the current URL without adding an entry to the history.
    Backbone.History.prototype.navigate = function(fragment, options) {
        if (!Backbone.History.started) {
            return false;
        }

        if (!options || options === true) {
            options = { trigger: Boolean(options) };
        }

        // Normalize the fragment.
        fragment = this.getFragment(fragment || '');

        // Don't include a trailing slash on the root.
        var rootPath = this.root;
        if (fragment === '' || fragment.charAt(0) === '?') {
            rootPath = rootPath.slice(0, -1) || '/';
        }
        var url = rootPath + fragment;

        // Strip the hash and decode for matching.
        fragment = this.decodeFragment(fragment.replace(pathStripper, ''));

        if (this.fragment === fragment) { return; }
        this.fragment = fragment;

        // If pushState is available, we use it to set the fragment as a real URL.
        if (this._usePushState) {
            var state = options.state !== undefined ? options.state : {};

            _handleNavigationDirection(state);

            this.history[options.replace ? 'replaceState' : 'pushState'](state, document.title, url);

            // If hash changes haven't been explicitly disabled, update the hash
            // fragment to store history.
        } else if (this._wantsHashChange) {
            this._updateHash(this.location, fragment, options.replace);
            if (this.iframe && fragment !== this.getHash(this.iframe.contentWindow)) {
                var iWindow = this.iframe.contentWindow;

                // Opening and closing the iframe tricks IE7 and earlier to push a
                // history entry on hash-tag change.  When replace is true, we don't
                // want this.
                if (!options.replace) {
                    iWindow.document.open();
                    iWindow.document.close();
                }

                this._updateHash(iWindow.location, fragment, options.replace);
            }

            // If you've told us that you explicitly don't want fallback hashchange-
            // based history, then `navigate` becomes a page refresh.
        } else {
            return this.location.assign(url);
        }
        if (options.trigger) { return this.loadUrl(fragment); }
    };

    module.exports = Backbone;
});
